import React from 'react';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';

interface IFormattedValue {
    suffix?: string;
    value: number;
}

export const FormattedValue = ({ suffix = '₽', value }: IFormattedValue) => {
    const unbreakSpace = '\u00a0';
    const formattedValue = `${separateThousands(value)}${unbreakSpace}${suffix}`;

    return (
        <Text tag="div" view="accent-primary-medium">
            {formattedValue}
        </Text>
    );
};
